/** Claims as the Auth provider hydrates them from the ID token; null until then. */
export type SessionClaims = Record<string, unknown> | null | undefined;

/**
 * True for a session opened from Poseidon: its custom token carries `via: 'poseidon'`.
 * Such a session belongs to a staff member, not to a user of the tenant, so the portal
 * hides the account settings that manage a tenant user and never assumes that a
 * `user::<tenant>::<email>` config exists for it.
 */
export function isInternalSession(claims: SessionClaims): boolean {
  return claims?.via === "poseidon";
}
